import React, { useEffect } from 'react';
import '../../shared/styles/our-purpose.css';
import { PurposeAccordion } from '../../shared/components/PurposeAccordion';
import { SEO } from '../../shared/components/SEO';

export default function ForOurPerformance() {
  useEffect(() => {
    document.body.classList.add('loaded');
    document.body.classList.add('zfast-theme-page');
    return () => {
      document.body.classList.remove('loaded');
      document.body.classList.remove('zfast-theme-page');
    };
  }, []);

  return (
    <>
      <SEO 
        title="For Our Performance | ZFAST Agritech India" 
        description="Learn about ZFAST Agritech India's performance metrics, our focus on customer satisfaction, and our goal of sustainable and profitable agritech growth." 
        path="/for-our-performance" 
      />
      <div className="zfast-clone-wrapper zfast-theme-page" dangerouslySetInnerHTML={{ __html: `
<div data-barba="container">
<header class="header--big">
<div class="header-background background--image">
<img alt="Performance and quality results background" class="header-background__image" loading="eager" width="1920" height="600" src="/images/about/our-performance.webp"/>
<div class="show-overlay"></div>
</div>
<div class="header-text">
<div class="container">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="header-text-titles">
<h1>for our performance</h1>
</div>
</div>
</div>
</div>
</header>
<section class="content-wrapper" id="content" role="main">
<div class="content-wrapper">
<article class="post-type-page" id="post-456">
<section class="article-content">
<div class="article-body">
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
</div>
<div class="col-12 col-lg-8 order-3 order-lg-2">
<div class="content">
<p>At ZFAST Agritech India, financial performance without purpose is not meaningful, and purpose without performance cannot endure for the long term. We are committed to driving sustainable agricultural growth in the Indian market, balancing profitability with our mission to deliver top-tier animal nutrition and support local farming communities. We have set two core ambitions for our performance.</p>
</div>
</div>
<div class="col-12 col-lg-4 order-1 order-lg-3">
<div class="container d-flex logo-container">
<img alt="EPR Business performance growth icon" decoding="async" loading="lazy" width="1024" height="1024" src="/images/home/zfast-sustainability-planet-icon.webp"/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${'/images/about/our-performance.webp'});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5 offset-md-6 offset-xl-7">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">1</span></div>
<h2 class="block__image-number--title">Customer satisfaction</h2>
<p class="block__image-number--content">To deliver real impact for Indian farmers through exceptional agritech products, premium animal feed, and reliable services.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
<div class="content">
<p class="~a10" id="+a10*c724[a0*b14[a0*]b38]c754[a10*b14[a0*]b39[a2*]b25[a10*]b24]c134|x0">At ZFAST Agritech India, performance is measured not just by business metrics, but by the tangible success of the farmers and dealers we partner with every day. By consistently delivering premium cattle feed, nutrient-rich pig feed, and reliable agricultural products, we ensure that our customers see measurable improvements in livestock health, milk yield, and overall farm profitability.</p>
<p>This unwavering commitment to customer satisfaction forms the foundation of our long-term vision. We believe that true industry leadership comes from empowering rural communities, optimizing supply chain efficiency, and maintaining uncompromising quality standards at every stage of our operations.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${'/images/about/performance.webp'});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">2</span></div>
<h2 class="block__image-number--title">Sustainable growth</h2>
<p class="block__image-number--content">To grow responsibly and profitably while championing sustainable agricultural practices and rural economic development.</p>
</div>
</div>
</div>
</div>
</div>
</section>
</div>
</section>
</article>
</div><!-- /content-wrapper -->
</section>

</div>
` }} />
      <PurposeAccordion />
    </>
  );
}
